/**
 * @author Ryan Gladstone, Umer Hassan
 */

function storyPitchingService($http, $q, $translate, platformService) {
  const service = {
    statuses: ['pitched', 'not watching', 'watching', 'saving', 'used']
  };

  service.calculateAvailablePitches = (incomingStory) => {
    const story = incomingStory;

    // grab open plans
    const openPlans = platformService.cache.all;

    // compare open plans to story's current pitches
    const currentPitches = [];
    angular.forEach(story.pitches, (pitch) => {
      if (
        pitch.currentStatus === 'pitched'
        || pitch.currentStatus === 'watching'
        || pitch.currentStatus === 'not watching'
        || pitch.currentStatus === 'saving'
        || pitch.currentStatus === 'used'
      ) {
        currentPitches.push(pitch.planPath);
      }
    });

    // reset available targets arrays
    story.websked.availablePitchTargets = [];
    story.websked.availableWithdrawTargets = [];

    const sortOutPlan = (plan) => {
      const planToSort = plan;
      // availablePitches
      if (currentPitches.indexOf(planToSort.path) === -1) {
        // reset the active flag because
        // otherwise it could remain from the last pitch panel open
        planToSort.active = false;
        story.websked.availablePitchTargets.push(planToSort);
      }

      // available withdraws
      if (currentPitches.indexOf(planToSort.path) !== -1) {
        planToSort.active = false;
        story.websked.availableWithdrawTargets.push(planToSort);
      }
    };

    angular.forEach(openPlans, (plan) => {
      sortOutPlan(plan);
    });

    return story;
  };

  return service;
}

const arr = [
  '$http',
  '$q',
  '$translate',
  'platformService',
  storyPitchingService
];

export default function (ngModule) {
  ngModule.service('storyPitchingService', arr);
}
